/* eslint-disable no-unused-vars */
/* eslint-disable react/no-children-prop */
import React from 'react';
import { useDispatch } from 'react-redux';
import { redirect } from 'store/Router/actions';
import get from 'lodash/get';
import { Severity } from 'Screens/Contextualization/Manage/components/ManageTable/components/Table/columns';
import FlagIcon from 'Common/Components/FlagIcon';
import {
  Wrapper, Trash, Text, IconWrapper
} from './styled';

const Vuln = ({
  vuln, deleteVuln, bgColor, isOdd
}) => {
  const vulnWs = get(vuln, 'workspace_name', '');
  const vulnId = get(vuln, 'id', 0);
  const dispatch = useDispatch();

  const handleClick = (e) => {
    if (e.ctrlKey || e.metaKey) {
      const newWindow = window.open(`manage/${vulnWs}/${vulnId}`, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    } else {
      dispatch(redirect(`/manage/${vulnWs}/${vulnId}`));
    }
  };

  return (
    <Wrapper bgColor={ bgColor } isOdd={ isOdd }>
      <Severity vuln={ vuln } />
      <FlagIcon theme={ vuln.confirmed ? 'confirmed' : 'notConfirmed' } />
      <Text onClick={ handleClick } confirmed={ vuln.confirmed } children={ vuln.name } />
      <IconWrapper>
        {!!deleteVuln && <Trash onClick={ deleteVuln } title="Remove" />}
      </IconWrapper>
    </Wrapper>
  );
};

export default Vuln;
